export const initialState = {
  place: {},
  users: {},
  services: {
    serviceId__service: {},
    indexServices: {
      name__service: {},
      namesServices: [],
    },
  },
  categories: {
    categoryId__category: {},
    index: {
      categoryId__productsId: {},
      productId_categoryNames: {},
      group__categoryIds: {},
      name__category: {},
      names: [],
    },
    categoryId_extraProducts: {},
    gorupCategoryId__categories: {},
  },
  toppings: {
    toppingId__topping: {},
    toppingGroupId__toppingsGroups: {},
    indexToppings: {
      name__toppingGroup: {},
      name__topping: {},
      namesToppings: [],
      namesToppingsGroups: [],
      toppingGroupId__toppings: {},
      toppingId_toppingGroupName: {},
    },
  },
  products: {
    productId__product: {},
    index: {
      name__product: {},
      names: [],
      code__product: {},
      codes: [],
    },
  },
  loading: false,
  initialized: false,
  error: false,
};
